export const environment = {
  production: true,
  api: 'Live',
  stripe_key: 'pk_live_rzRqp5mMeA4zqvCCIBnTZrqK',
  api_url: 'https://api2.tractorzoom.com/',
  web_user_url: 'https://www.tractorzoom.com/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts